import useSWRMutation, {
  SWRMutationConfiguration,
  SWRMutationResponse,
} from 'swr/mutation';
import axiosInstance from '@api/axios';
import { Key } from 'swr/_internal';

interface UseMutationOptions<TResponse, TRequest>
  extends SWRMutationConfiguration<TResponse, any, Key, TRequest> {
  url: string | ((arg: TRequest) => string);
  method: 'post' | 'put' | 'patch' | 'delete';
  headers?: Record<string, string>;
}

/**
 * Currently is not working properly with PATCH, PUT and DELETE methods
 * It has some limitations when your URL is a function
 * You should use direct axios calls instead
 */
export default function useMutation<TResponse, TRequest = any>(
  options: UseMutationOptions<TResponse, TRequest>
): SWRMutationResponse<TResponse, any, Key, TRequest> {
  const { url, method, headers, ...config } = options;

  const fetcher = async (_key: string, { arg }: { arg: TRequest }) => {
    const finalUrl = typeof url === 'function' ? url(arg) : url;

    const response = await axiosInstance({
      method,
      url: finalUrl,
      data: arg,
      headers,
    });
    return response.data;
  };

  const finalUrl =
    typeof url === 'function' ? String(url({} as TRequest)) : url;

  if (!finalUrl) {
    throw new Error('useMutation: URL is required');
  }

  return useSWRMutation<TResponse, any, Key, TRequest>(
    finalUrl,
    fetcher,
    config
  );
}
